// react-to-print normally reloads stylesheet links in its iframe. Read the
// rules already loaded in the app so ticket printing does not need the network.
export const getLoadedPrintStyles = requiredClassName => {
  let hasRequiredStyle = false;
  const rules = [];

  for (const sheet of document.styleSheets) {
    if (
      sheet.href &&
      new URL(sheet.href, document.baseURI).origin !== window.location.origin
    ) {
      continue;
    }

    try {
      for (const rule of sheet.cssRules) {
        const css = rule.cssText;
        if (css.includes(`.${requiredClassName}`)) hasRequiredStyle = true;
        rules.push(css);
      }
    } catch (error) {
      // Browser extensions and third-party styles may deny CSSOM access.
      console.warn("Could not read a stylesheet for ticket printing", error);
    }
  }

  if (!hasRequiredStyle) {
    throw new Error(
      "Ticket styles are unavailable. Please reconnect before printing.",
    );
  }

  return rules.join("\n");
};
